/**
 * Converts a URL path into a CSS class–friendly string.
 * "/about/team" --->  "about-team"
 * "products/audio/mixer" ---> "products-audio-mixer"
 * "/" ---> ""
 */
export const linkToClass = (url: string) : string => {
    /*let linkToClass = '';
    if (url.charAt(0) === '/') linkToClass = url.substring(1);
    linkToClass = linkToClass.replace(/\//g, '-');
    return linkToClass;*/

    if (!url) return '';

    let result = url.trim();

    // Remove leading slash (if present) ----------------
    if (result.startsWith('/')) {
        result = result.slice(1);
    }

    // Replace all slashes with hyphens ------------------
    result = result.replace(/\//g, '-');

    return result.toLowerCase();
};